import React, { createContext, FC } from "react";
import { Config } from "../use-config/models/Config";
import useConfig from "../use-config/use-config";

interface AppContextState {
    config: Config | null
}

const AppContext = createContext({} as AppContextState);

const AppContextProvider: FC = (props) => {
  const config = useConfig()
  return (
    <AppContext.Provider value={{config}}>
      {props.children}
    </AppContext.Provider>
  );
};

export { AppContext, AppContextProvider, AppContextProvider as default };

